module.exports = __webpack_public_path__ + "img/lock-red-icon.94a1be6a.svg";